
import dojoxHorizontalRenderer from 'dojox/calendar/HorizontalRenderer';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from 'dojox/calendar/templates/HorizontalRenderer.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';
import query from 'dojo/query';
import tap from 'dojox/gesture/tap';

import domStyle from 'dojo/dom-style';
import domConstruct from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import domAttr from 'dojo/dom-attr';
import methodHooks from 'more/mdsMethodHooks';



class moreCoreHorizontalRenderer extends methodHooks(compose(dojoxHorizontalRenderer)) {
	[key: string]: any;

	templateString: any = template;

	_doubleTouchHandler: any = null;
	_singleTapHandler: any = null;
	bHideColumHeadIfNeeded: boolean = false;
	bShowEndTime: boolean = false;


	_isElementVisible (elt :string, startHidden?:any, endHidden?:any, size?:any): boolean { //// I simmply don't know what those arguments do: a solid dive into dojo needed for typing

		switch (elt) {
			case "startTimeLabel":
				if (this.item.allDay) {
					return false;
				}
				return this.bHideColumHeadIfNeeded == false;

		}

		let self: any = this;
		return super._isElementVisible.apply(this, arguments as any);
	}

	updateRendering (w, h) : void {
		let self: any = this;
		super.updateRendering.apply(this, arguments as any);

		//console.log("UpdateR")

		var rd :any = this.owner.renderData;
		var size: any = this._orientation == "vertical" ? h : w;
		var startHidden: boolean = rd.dateModule.compare(this.item.range[0], this.item.startTime) != 0;
		var endHidden: boolean = rd.dateModule.compare(this.item.range[1], this.item.endTime) != 0;
		var visible : boolean;

		if (this.startTimeLabel) {
			visible = this._isElementVisible("startTimeLabel", startHidden, endHidden, size);

			domStyle.set(this.startTimeLabel, "display", visible ? this.getDisplayValue("startTimeLabel") : "none");
			if (visible) {
				var timeText: string = this._formatTime(rd, this.item.startTime);
				if (this.bShowEndTime === true) {
					timeText = timeText + " - " + this._formatTime(rd, this.item.endTime);
				}
				(this._setText as any)(this.startTimeLabel, timeText);
			}
		}

		//var extraNode = domConstruct.create("div", { "innerHTML": "xyz extra" }, this.labelContainer);
		
		var itemColor: { backColor: string, textColor: string } = this.getItemColor(this.item._item);
		if (!itemColor) {
			
			itemColor = this.getItemColor(this.item._item);
        }
		if (itemColor) {
			// ob die Hexwerte nun mit oder ohne "#" kommen is uns wurscht
			var colorBack: string = itemColor.backColor;
			var colorText: string = itemColor.textColor;
			if (colorBack.indexOf("#") == -1) colorBack = "#" + colorBack;
			if (colorText.indexOf("#") == -1) colorText = "#" + colorText;

			//query(".bg", this.domNode).style({ "backgroundColor": colorBack }); /// ersetzt durch n�chste 4 zeilen
			let Collection: HTMLCollection = (<HTMLCollection>(<any>query(".bg", this.domNode)));
			for (let j = 0; j < Collection.length; j++) {
				domStyle.set(<HTMLElement>Collection[j], "backgroundColor", colorBack);
			}

			domStyle.set(this.summaryLabel, { "color": colorText });
			domStyle.set(this.startTimeLabel, { "color": colorText });
		}
		//2021.01.20 ------START

		var columnViewHead: HTMLCollection = <HTMLCollection>(<any>query(".columnViewHead", this.startTimeLabel));
		if (columnViewHead.length > 0) {
			domAttr.set(columnViewHead[0], "innerHTML", this.item._item.columnview_head_text);
		} else {
			domConstruct.create("span", {
				"class": "columnViewHead",
				"innerHTML": this.item._item.columnview_head_text
			}, this.startTimeLabel, "last");
		}

		//  Attribut f�r Saltenansicht (Inhalt) setzen
		//
		if (this.item.allDay) {

			var allDayItemText : string = this.item._item.columnview_head_text + ": " + this.item._item.columnview_body_text;

			domConstruct.create("div", {
				"innerHTML": allDayItemText,
				"style": "width: 100%; text-align: center; text-overflow:ellipsis;"
			}, this.summaryLabel, "only");
		}
		//2021.01.20 ------END


		//2022.10.17 ------START
		let columnViewHeadElement = <HTMLElement>columnViewHead[0];
		let summaryLabelElement = <HTMLElement>this.summaryLabel.lastElementChild;

		if (visible && !this.item.allDay && columnViewHeadElement?.innerText === summaryLabelElement.innerText) {

			domClass.add(this.summaryLabel, "w3-hide");
		} else {

			domClass.remove(this.summaryLabel, "w3-hide");
        }
		//2022.10.17 ------END
	}

	getItemColor(item): { backColor: string, textColor: string } {
		//
		//  wird in mainProperties �berschrieben!
		//  haxxxxx0r
		//
		return { backColor: "white", textColor: "black" }; // default colors
	}
	_onItemDoubleTouch ():void {
		// event nur bei touch-ger�ten auf onItemDoubleClick umleiten

		if ("ontouchstart" in document.documentElement) {
			this.owner._onItemDoubleClick({ item: this.item._item });
		}

	}
	_attachDoubleTouchEvent (): void {
		this._detachDoubleTouchEvent();

		if ("ontouchstart" in document.documentElement) {
			this._doubleTouchHandler = on(this.domNode, tap.doubletap, lang.hitch(this, "_onItemDoubleTouch"));
		}
	}
	_detachDoubleTouchEvent ():void {
		if (this._doubleTouchHandler != null) {
			this._doubleTouchHandler.remove();
		}
	}
	_recycleRenderer ():void {
		let self: any = this;
		super["_recycleRenderer" as any].apply(this, arguments as any);

		this._detachDoubleTouchEvent();
	}

	_onItemSingleTap (evt) {
		// event nur bei touch-ger�ten auf onItemClick umleiten
		if ("ontouchstart" in document.documentElement) {
			this.owner._onItemClick({ item: this.item._item });
		}
	}
	_attachSingleTapEvent():void  {
		this._detachSingleTapEvent();

		this._singleTapHandler = on(this.domNode, tap, lang.hitch(this, "_onItemSingleTap"));
	}
	_detachSingleTapEvent ():void  {
		if (this._singleTapHandler != null) {
			this._singleTapHandler.remove();
		}
	}

	postCreate(): void {
		let self: any = this;
		super.postCreate.apply(this, arguments as any);
		
		self._applyAttributes();

		if ("ontouchstart" in document.documentElement) {
			this._attachDoubleTouchEvent();
			this._attachSingleTapEvent();
		}

		topic.subscribe("moreCoreCalendar/bShowEndTime", lang.hitch(this, function (bool) {
			this.bShowEndTime = bool;
		}));

		topic.subscribe("MainProperties/cbShowEndTime_checked", lang.hitch(this, function (bool) {
			this.bShowEndTime = bool;
		}));

		topic.subscribe("moreCoreCalendar/bHideColumHeadIfNeeded", lang.hitch(this, function (bool) {
			this.bHideColumHeadIfNeeded = bool;
		}));

	}


	startup(): void {
		// required for dojo inheritance to call the superclass
		let self: any = this;
		super.startup.apply(this, arguments as any);

	}


}

export default mdsWidget(moreCoreHorizontalRenderer);